module.exports = new __parcel__URL__("walletConnect.ccd839a8.svg").toString();